// extracted by mini-css-extract-plugin
module.exports = {"landing":"_1tuEXrmCuXHA-q2eugoM_I"};